import React, { MouseEvent, useState } from 'react' 
import IScalarForm, { IScalarObject } from '../interface/IScalarForm'
import { Button, Popover, Position } from '@blueprintjs/core'
import { __ } from 'src/libs/utilities'
import SubMenu from '../SubMenu'

const Scalar = (props: (IScalarForm & IScalarObject) ) : JSX.Element => {
  const {
    title, subtitle, description, commentary, autoFocus, 
    value, 
    vertical, field, prefix, postfix, 
    editable, notClear, subMenus, onSubMenu,
    enabledForm, desabledForm
  } = props

  const [noDefault, setNoDefault] = useState<boolean>( !!props.noDefault )
  const className = props.className ? props.className : "mt-3 form-control input dark"

  const onClear = () => {
    if(props.onClear) {
      props.onClear( props.field || "" )
      return
    }
    if( props.onChange ) {
      props.onChange( "", props.field, "" ) 
    } 
  }
  const onChange = (evt: any) => { 
    if( props.onChange ) { 
      props.onChange( evt.target.value, props.field, "" )
    } 
  }
  const col1 = title || description
    ? 
    vertical
      ? 
      "col-12 layout-label-vert  p-0"
      : 
      "col-md-3  layout-label"
    : 
    " hidden "
  const col2 = title || description
    ?
    vertical
      ? 
      "col-12 layout-data-vert  p-0"
      : 
      "col-md-9 layout-data p-0"
    : 
    " col-12 layout-data-vert  p-0"
  const descr = description
    ? 
    <Popover
      position={Position.RIGHT}
      interactionKind="hover"
      content={<div className="p-4 square" dangerouslySetInnerHTML={{ __html: __(description as string) }} />}
    >
      <Button variant="minimal" icon="help" />
    </Popover>      
    : 
    null
  const enabled = () : React.ReactElement  => {
    return <input
      data-testid="scalar-string"
      autoFocus={ autoFocus }
      placeholder={props.placeholder} 
      type="text"
      role="article"
      pattern={ props.accept }
      className={`${ className ? className : "form-control input dark"} flex-grow-100 `}
      value={ ( value || "" ).toString() }
      onChange={ onChange }
    /> 
  }
  const disabled = () : React.ReactElement  => {
    return <div className={`  my-2 ${ className }`} dangerouslySetInnerHTML={{ __html: ( value || "" ).toString()}} />
  }
  const onMouseDown = (evt: MouseEvent) => {
    evt.stopPropagation()
    //evt.preventDefault()
  } 
  const required: boolean = !!props.required && !Array.isArray( props.required )
  return <div
    className={`row dat strob01 ${props.rowClassName ? props.rowClassName : ""}`}
    data-row={ field }
    data-testid={props["data-testid"]}
    onClick={() => setNoDefault( false)}
    onDragStart={onMouseDown}
    onMouseDown={onMouseDown}
  >
    <SubMenu
      subMenus={subMenus}
      on={onSubMenu}
    />
    {
      subtitle 
        ?
        typeof subtitle === "string" 
          ?
          <div className="title small mt-3 mb-1 px-3 col-md-12 pointer" dangerouslySetInnerHTML={{ __html: __( subtitle || "") }} /> 
          :
          <div className="title small mt-3 mb-1 px-3 col-md-12 pointer">{subtitle}</div>
        :
        <></>
    }
    <div className={col1}>
      <span className={ required ? "text-danger" : ""}>
      {
        typeof title == "string"
          ?
          __(title as string)
          :
          title
      }
      </span>
      {
        required && <div className='text-light bg-danger position-absolute top left px-2 descr small'><div className='small'>{ __("Required field") }</div></div>
      }
      { descr } 
    </div>
    <div className={col2}> 
      <div className="d-flex w-100"> 
        {
          prefix ? <span className="prefix">{prefix}</span> : null
        }
        <div className="d-flex flex-grow-100 max-width-100">
        {
          !!editable 
            ? 
            !!noDefault && !(!!value || !!value?.length)
              ?
              <div className='mb-2'></div>
              :
              !!enabledForm  ? enabledForm : enabled() 
            : 
            !!desabledForm ? desabledForm : disabled()
        }
        </div>
        {
          !!postfix && (!noDefault || !!value) ? <span className="postfix">{postfix}</span> : null
        }            
        {
          !!editable && !notClear  && (!noDefault || !!value)
            ? 
            <Button
              className="right"
              icon="cross"
              variant="minimal"
              onClick={ onClear }
            />
            :
            null
        }
      </div> 
    </div>
    {
      !!commentary  && (!noDefault || !!value)
        &&
        <div className="scalar-commentary px-3 col-md-9 offset-md-3" dangerouslySetInnerHTML={{ __html: __(commentary as string) }} /> 
    } 

  </div>
} 

export default Scalar